// eslint-disable-next-line no-restricted-imports -- Error pages render without application providers.
import { Button, Center, Flex, Heading, SimpleGrid, Text } from "@chakra-ui/react";
import { useNavigate } from "@remix-run/react";
import { json } from "@remix-run/node";
import type { LoaderArgs, TypedResponse } from "@remix-run/node";

export function loader(_args: LoaderArgs): TypedResponse<null> {
  return json(null, { status: 404 });
}

export function NotFound(): JSX.Element {
  const navigate = useNavigate();
  return (
    <Center mt="lg">
      <SimpleGrid gap="md">
        <SimpleGrid gap="sm">
          <Heading>Page Not Found</Heading>
          <Text>The page you&apos;re looking for can&apos;t be found.</Text>
        </SimpleGrid>

        <Flex gap="sm">
          <Button onClick={(): void => navigate("/")} size="sm" variant="outline" w="max-content">
            Go Home
          </Button>

          <Button
            colorScheme="rose"
            onClick={(): void => navigate("/login")}
            size="sm"
            w="max-content"
          >
            Login / Sign Up
          </Button>
        </Flex>
      </SimpleGrid>
    </Center>
  );
}

export default NotFound;
